import {makeAutoObservable} from "mobx";
import history from '../authentication/History';
import {toast} from 'react-toastify';
import environment from '../environments';
import {apiFetch, notifyError} from '../api';

const emptyTerms = () => ({});

class TermsStore
{

    termsList = [];
    terms = emptyTerms();
    /* ID of the record in terms, so a different record never shows stale data */
    loadedId = null;

    start = 0;
    limit = 100;
    searchTerm = "";

    /* Endpoints */
    detailRoute = "/terms";
    dataEndpoint = environment.API_HOST + "/terms-admin/list";
    searchEndpoint = environment.API_HOST + "/terms-admin/search";

    /* Table configuration */
    sortBy = "active";
    sortOrder = "desc";
    tableColumns = [
        {name: "Angelegt", field: "created", type: "date", sortable: true},
        {name: "Aktualisiert", field: "updated", type: "date", sortable: true},
        {name: "Anmerkung", field: "note", sortable: false},
        {name: "Aktiv", field: "active", type: "bool", sortable: true},
        {name: "Zustimmungen", field: "agreements", sortable: true},
    ]

    constructor()
    {
        makeAutoObservable(this)
    }

    getTermsList()
    {
        apiFetch(this.dataEndpoint + "?start=" + this.start + "&limit=" + this.limit + "&sortBy=" + this.sortBy +
            "&sortOrder=" + this.sortOrder)
            .then((json) =>
            {
                this.termsList = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
                return error;
            })
    }

    searchTerms()
    {
        /* Start again on the first page */
        this.start = 0;

        if (this.searchTerm && this.searchTerm.length > 0)
        {
            const term = this.searchTerm;
            apiFetch(this.searchEndpoint + "?term=" + encodeURIComponent(term))
                .then((json) =>
                {
                    if (term === this.searchTerm)
                    {
                        this.termsList = json.data
                    }
                })
                .catch((error) =>
                {
                    notifyError(error);
                })

        } else
        {
            this.getTermsList();
        }
    }

    addTerms()
    {
        apiFetch(environment.API_HOST + "/terms-admin/new", {
            method: 'POST',
        })
            .then((json) =>
            {
                history.push('/terms/' + json.data.id)
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    getTerms(id)
    {
        if (this.loadedId !== id)
        {
            this.terms = emptyTerms();
            this.loadedId = id;
        }

        apiFetch(environment.API_HOST + "/terms-admin/" + id)
            .then((json) =>
            {
                /* Ignore responses for a record that is no longer open */
                if (id !== this.loadedId)
                {
                    return;
                }

                this.terms = json.data[0]
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    saveTerms(id)
    {
        var payload = {
            active: this.terms.active,
            note: this.terms.note,
            terms_de: this.terms.terms_de,
            terms_en: this.terms.terms_en,
        }

        payload = JSON.stringify(payload);

        apiFetch(environment.API_HOST + "/terms-admin/" + id, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        })
            .then((json) =>
            {
                toast.success("Nutzungsbedingungen erfolgreich gespeichert.");
                this.getTerms(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    deleteTerms(id)
    {
        apiFetch(environment.API_HOST + "/terms-admin/" + id, {
            method: 'DELETE',
        })
            .then((json) =>
            {
                history.push('/terms')
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    sort(column)
    {
        /* Start again on the first page */
        this.start = 0;

        this.sortBy = column;

        if (this.sortOrder === 'asc')
        {
            this.sortOrder = 'desc';
        } else
        {
            this.sortOrder = 'asc';
        }

        this.getTermsList();
    }

    nextPage()
    {
        this.start = this.start + this.limit
        this.getTermsList();
    }

    previousPage()
    {
        if (this.start - this.limit >= 0)
        {
            this.start = this.start - this.limit
            this.getTermsList();
        }
    }
}

const termsStore = new TermsStore();
export default termsStore;
